import { Http } from '@/services/http'
import { ParamsClean } from '@/common/decorators/params-clean'
import { Injectable } from '@tanbo/vue-di-plugin'
import { PatchInfo } from '@/views/dashboard/safe-status/vulnerability-fix/vulnerability-fix.service'

export interface TerQueryParams {
  /** 补丁编号 */
  kb_number: string
  /** 页码 */
  page: number
  /** 每页数量 */
  limit: number
}

export interface RepairQueryParams {
  /** 补丁编号 */
  kb_number: string
  /** 终端设备id列表 */
  device_list: string[]
}

export interface IgnoreQueryParams {
  /** 补丁编号 */
  kb_numbers: string[]
}

export interface TerminalList {
  /** 终端设备id */
  device_id: string
  /** 计算机名 */
  computer_name: string
  /** 登录状态 */
  login_status?: number
  /** 系统类型 1-windows 2-linux */
  system_type?: number
  /** 分组id */
  group_id: number
  /** 分组名 */
  group_name: string
  /** 外网IP */
  system_ip: string
  /** 内网IP */
  client_ip: string
  /** 操作系统 */
  os: string
  /** 扫描时间 */
  scan_time: number
  /** 修复状态 "未修复": 0,"修复中": 1 */
  fix_status: number
}

export interface RepairRequestParams {
  /** 终端设备id */
  device_id: string
  /** 补丁编号列表 */
  kb_numbers?: string[]
}

export interface RepairResponseData {
  /** 指令任务id */
  task_id: string
}

@Injectable()
export class LeakViewService {
  constructor (private http: Http) {}

  @ParamsClean()
  getTerminals (data: TerQueryParams) {
    return this.http.post<{
      list: TerminalList[]
      total: number
    }>('/leak/leak-view/get-terminals', data)
  }

  repairLeak (data: RepairQueryParams) {
    return this.http.post<void>('/leak/leak-view/repair', data)
  }

  ignoreLeak (data: IgnoreQueryParams) {
    return this.http.post<void>('/leak/ignore', data)
  }
  // 漏洞编号批量修复指令
   getLeakLeakNumberRepair (data: RepairRequestParams) {
    return this.http.post<RepairResponseData>('/leak/leak-number/repair', data)
  }
}

